<div
  [ngClass]="{
    'my-2': group.questions.length === 1,
    'my-3': group.questions.length > 1,
    'd-none': question.reference === 'MARITAL_STATUS_OTHER'
  }">
  <form [formGroup]="formData">
    <label
      *ngIf="
        group.name === 'people who are important to me' ||
        group.name === 'personal details' ||
        group.name === 'relative'
      "
      >{{ question.label }}</label
    >
    <input
      class="form-control"
      type="text"
      formControlName="field"
      [ngClass]="{ 'is-invalid': form.field.errors }" />
    <div
      class="mt-2"
      *ngIf="form.field.errors"
      style="font-size: 80%; color: rgb(244 106 106)">
      <span *ngIf="form.field.errors.required"
        >Please provide a valid response.</span
      >
      <span *ngIf="form.field.errors.maxlength"
        >This value is too long. It should have
        {{ questionParams.maxLength }} characters or fewer.</span
      >
    </div>
  </form>
</div>
